import { Dialog, GanttChart, GanttChartToolbar } from "@/components"
import usePreviewPlan from "./usePreviewPlan"
import { Drawer, DrawerClose, DrawerContent, DrawerHeader } from "@/components/ui";
import { AddEditTask } from "../Task";
import { X } from "lucide-react";

const PreviewPlan = () => {
  const {
    chartData,
    globalFilter,
    setGlobalFilter,
    onChangeTask,
    currTask,
    columns,
    onExpandAll,
    onCollapseAll,
    zoomIn,
    zoomOut,
    zoom,
    isDeletePending,
    onSelectTask,
    onEditClick,
    showEditDelete,
    onToday,
    timelineRange,
    onDeleteClick,
    showView,
    openTaskDrawer,
    setOpenTaskDrawer,
    isTaskExist,
    taskList,
    taskData,
    isView,
    showDeleteConfirmation,
    setShowDeleteConfirmation,
    onDeleteTask
  } = usePreviewPlan();

  return (
    <div className="bg-white rounded-[6px] border-1 overflow-hidden">
      <GanttChartToolbar onExpandAll={onExpandAll}
        onCollapseAll={onCollapseAll}
        zoomIn={zoomIn}
        zoomOut={zoomOut}
        showEditDelete={showEditDelete}
        isDeletePending={isDeletePending}
        onDeleteTask={onDeleteClick}
        onEditClick={onEditClick}
        onToday={onToday}
        onChangeTask={onChangeTask}
        currTask={currTask}
        globalFilter={globalFilter}
        setGlobalFilter={setGlobalFilter}
        showView={showView}
      />
      <GanttChart data={chartData} columns={columns} scale={zoom} onSelectTask={onSelectTask}
        start={timelineRange?.start || ""}
        end={timelineRange?.end || ""}
      />
      <div className="flex flex-wrap gap-2">
        <Drawer open={openTaskDrawer} onClose={() => setOpenTaskDrawer(false)} direction="right">
          <DrawerContent className="bg-white md:!max-w-[450px] md:!w-[450px]">
            <DrawerHeader className="font-semibold font-[22px] flex items-center justify-between flex-row">
            {isView ?
                `View ${taskData?.taskName || ''} Detail` : taskData ? `Edit ${taskData?.taskName || ''} Detail` 
                : 'Add Task'}
              <DrawerClose className="cursor-pointer"><X /></DrawerClose>
            </DrawerHeader>
            <AddEditTask isTaskExist={isTaskExist} taskList={taskList} fromPreview />
          </DrawerContent>
        </Drawer>
      </div>
      <Dialog
        open={showDeleteConfirmation}
        setOpen={setShowDeleteConfirmation}
        title="Confirmation"
        onSave={onDeleteTask}
        saveBtnClassName="bg-red-600 text-white hover:bg-red-600 hover:text-white"
        saveText="Delete">
        <div className="flex flex-col gap-4">
          <p>Are you sure you want to delete selected task?</p>
        </div>
      </Dialog>
    </div>
  )
}

export default PreviewPlan;